import { useEffect } from 'react'
import { getBottomPadding } from '../../../../../utils/sessionStorage'
import { EventNames } from '../../../../../types/misc.types'
import { trackEvent } from '../../../../../utils/appBridge'
import { PlansSipListScreenByPlanMode } from '../../analytics/plansEvents'
import { SipPlanMode } from '../api/types'
import { SipIdealPageContent } from './SipIdealPageContent'
import { SipPlansProvider, useSipPlansContext } from './SipPlansProvider'
import { SipPlansTopHeader } from './topHeader/SipPlansTopHeader'
import { SipYourPlanPageContent } from './SipYourPlanPageContent'

const SCROLL_PANEL_CLASS_NAME =
  'absolute inset-0 min-h-0 overflow-y-auto overflow-x-hidden no-scrollbar overscroll-none bg-[#F0F4F7]'

const SCROLL_PANEL_STYLE = {
  overscrollBehavior: 'none' as const,
  overflowAnchor: 'none' as const,
  WebkitOverflowScrolling: 'auto' as const,
  touchAction: 'pan-y' as const
}

export default function SipPlansPage() {
  return (
    <SipPlansProvider>
      <SipPlansPageContent />
    </SipPlansProvider>
  )
}

function SipPlansPageContent() {
  const { planMode } = useSipPlansContext()
  const isYourPlanActive = planMode === SipPlanMode.YOUR_PLAN
  const isIdealActive = planMode === SipPlanMode.IDEAL_SIPS

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        ScreenName: PlansSipListScreenByPlanMode?.[planMode]
      }
    })
  }, [planMode])

  return (
    <div
      className="relative h-screen flex flex-col min-h-0 overflow-hidden bg-white"
      style={{
        paddingBottom: `calc(${getBottomPadding()}px)`
      }}
    >
      <SipPlansTopHeader />
      {/* One scroll container per underline tab, both kept mounted. `invisible` preserves each
          panel's scrollTop; `hidden` (display:none) would reset it on every tab switch. */}
      <div className="relative flex-1 min-h-0 overflow-hidden">
        <div
          className={`${SCROLL_PANEL_CLASS_NAME} ${isYourPlanActive ? 'z-[1]' : 'invisible pointer-events-none z-0'}`}
          style={SCROLL_PANEL_STYLE}
          aria-hidden={!isYourPlanActive}
        >
          <SipYourPlanPageContent />
        </div>
        <div
          className={`${SCROLL_PANEL_CLASS_NAME} ${isIdealActive ? 'z-[1]' : 'invisible pointer-events-none z-0'}`}
          style={SCROLL_PANEL_STYLE}
          aria-hidden={!isIdealActive}
        >
          <SipIdealPageContent />
        </div>
      </div>
    </div>
  )
}
